import axiosRequest from '@/utils/axios-default-request';



// 聊天公共接口

// 获取某个会话的历史数据     "supConversationId":8会话id
let sessionHistory = (data)=>axiosRequest.postBodyJson('/communicationinterface/sessionHistory',data)

// 打开某个会话信息状态置为已读 "supConversationId": 8,会话id "senderId": 1 当前登录者的id
let readMessage = (data)=>axiosRequest.postBodyJson('/communicationinterface/readMessage',data)

// 发送消息  "userName":" ",接收人   "message":" "发送内容
let messageSending = (data) =>axiosRequest.postBody('/communicationinterface/messageSending',data)

// 保存即时沟通消息记录  
    /**supConversationId": 1,会话id
    "messageContent": "111111",消息内容
    "senderId": 1,当前登陆者的用户id
    "contentType": 0 消息类型（0文本，1文件，2图片）
    */
let addContact = (data) =>axiosRequest.postBodyJson('/communicationinterface/addContact',data)


// 创建会话
let ceatesession  = (data) =>axiosRequest.postBody('/communicationinterface/ceatesession',data)

// 需求端
/**
 *需求方即时沟通聊天列表
 *    "userId":1,当前登陆者的用户id
    "keyword":"", 关键词（搜索）
    "type":"2" 类型 全部 0/已读 1/未读 2
 * */ 
let getXQContactList = (data)=>axiosRequest.postBodyJson('/communicationinterface/getXQContactList',data)

// 译员端
let getGYSContactList = (data)=>axiosRequest.postBodyJson('/communicationinterface/getGYSContactList',data)


// 需求方未读
let getXQUnreadmessage = (data)=> axiosRequest.postBodyJson('/communicationinterface/getXQUnreadmessage',data)


// 译员端未读
let getGYSUnreadmessage = (data)=> axiosRequest.postBodyJson('/communicationinterface/getGYSUnreadmessage',data)

// 撤回消息
let getRecallMessage = (data)=> axiosRequest.postBodyJson('/communicationinterface/getRecallMessage',data)

export default{
    getXQContactList,//需求方即使沟通聊天列表
    sessionHistory,//获取某个绘画的历史数据 
    readMessage,//打开某个会话信息状态置为已读
    messageSending,// 发送消息
    addContact,// 添加聊天信息
    getGYSContactList,//获取译员端聊天用户列表
    ceatesession,//创建会话
    getXQUnreadmessage,//需求方未读消息
    getGYSUnreadmessage,//译员端未读
    getRecallMessage,//撤回消息
}